import * as React from "react";
import { useRouter } from "next/router";
import { useMaintenance } from "@nju/data-access-portal-technical";
import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import {
  DashboardMainPaymentPage,
  DashboardPaymentSubmenu,
} from "@nju/feature-portal-payment";
import { portalRoutes } from "@nju/routes";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../../components/ClientSideRenderer";

export default function MyPayments() {
  const [isReady, setIsReady] = React.useState(false);
  const router = useRouter();
  const { paymentsUnavailable } = useMaintenance();
  const payByLink = portalRoutes.mojeKonto.platnosci.index.hasParam(
    router.query,
    "type",
  );

  React.useEffect(() => {
    if (payByLink) {
      if (
        window.sessionStorage.getItem("external-payment-flow") ===
        "mobile-fulfillment"
      ) {
        window.sessionStorage.removeItem("external-payment-flow");
        router.push(portalRoutes.mojeKonto.index.get({ mode: "mobile" }));
      }

      if (
        window.sessionStorage.getItem("external-payment-flow") ===
        "ftth-onboarding"
      ) {
        window.sessionStorage.removeItem("external-payment-flow");
        router.push(portalRoutes.terminInstalacji.get());
      }
    }
    setIsReady(true);
  }, [payByLink, router]);

  if (!isReady) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  if (paymentsUnavailable) {
    router.replace(portalRoutes.trwajaPrace.get());
    return;
  }

  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="primary">
        <ClientSideOnly>
          <RequiredDashboardData extendedMode="mobile">
            <Navigation title="płatności" />
            <DashboardPaymentSubmenu />
            <DashboardMainPaymentPage />
          </RequiredDashboardData>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
